/**
 * @module nhcweb/apps/shared/nhc-modules/mouse-coordinates
 */
import './mouse-coordinates.css';
import { Control } from 'ol/control';
import { toLonLat } from 'ol/proj';

/**
 * @description
 * Add the latitude/longitude display to the map
 */
export class MouseCoordinates extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    // Default options
    options.target = options.target || document.body;

    const element = document.createElement('div');
    element.id = 'mouse-coordinates';
    element.className = 'mouse-coordinates ol-unselectable ol-control';

    super({
      element: element,
      target: options.target,
    });

    // Set initial content of latlon div
    element.textContent = 'Mouse Lat/Lon: -, -';

  }

  /**
   * Overriding the setMap method to add the event listener. This ensures
   * that the event listener is added after the control is added to the map.
   * @param {object} map 
   */
  setMap(map) {
    // Call the parent method.
    super.setMap(map);
  
    // Register the event handler if the map is not null.
    if (map) {
      // Update mouse-coordinates div when mouse moves over the map
      map.on('pointermove', (evt) => {
        const coordinate = evt.coordinate;
        const lonLat = toLonLat(coordinate);
        const lon = lonLat[0].toFixed(1);
        const lat = lonLat[1].toFixed(1);
        const format = `Mouse Lat/Lon: ${lat}, ${lon}`
        this.element.textContent = format;
      });
    }
  }

}
